import { render, staticRenderFns } from "./PassportCopies.vue?vue&type=template&id=f8c9b3e8&scoped=true"
import script from "./PassportCopies.vue?vue&type=script&lang=js"
export * from "./PassportCopies.vue?vue&type=script&lang=js"
import style0 from "./PassportCopies.vue?vue&type=style&index=0&id=f8c9b3e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c9b3e8",
  null
  
)

export default component.exports